import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  GetWorkspaceListReq,
  GetWorkspaceListResp,
  GetWorkspaceDetailReq,
  GetWorkspaceDetailResp,
  UpsertWorkspaceDraftReq,
  UpsertWorkspaceDraftResp,
  SubmitWorkspaceDraftReq,
  SubmitWorkspaceDraftResp,
  DeleteWorkspaceDraftReq,
  DeleteWorkspaceDraftResp,
  GetNpcPrologueVoiceReq,
  GetNpcPrologueVoiceResp,
  DraftModerationReq,
  DraftModerationResp,
  GetWorkspaceBannerReq,
  GetWorkspaceBannerResp,
  GetChatModelsResp,
} from '../types';

export const postWorkspaceList = async (
  data: GetWorkspaceListReq,
  config?: AxiosRequestConfig
): Promise<GetWorkspaceListResp> => {
  const url = '/weaver/api/v1/npc/workspace/list';

  return await request.post(url, data, config || {});
};

export const postWorkspaceDetail = async (
  data: GetWorkspaceDetailReq,
  config?: AxiosRequestConfig
): Promise<GetWorkspaceDetailResp> => {
  const url = '/weaver/api/v1/npc/workspace/detail';

  return await request.post(url, data, config || {});
};

// 获取agent npc基本信息
export const postGetUGCAgent = async (
  data: {
    agent_id: string;
  },
  config?: AxiosRequestConfig
) => {
  const url = '/weaver/api/v1/ugc/agent/get_ugc_agent';

  return await request.post(url, data, config || {});
};

export const postWorkspaceDraftUpsert = async (
  data: UpsertWorkspaceDraftReq,
  config?: AxiosRequestConfig
): Promise<UpsertWorkspaceDraftResp> => {
  const url = '/weaver/api/v1/npc/workspace/draft_upsert';

  return await request.post(url, data, config || {});
};

export const postWorkspaceDraftSubmit = async (
  data: SubmitWorkspaceDraftReq
): Promise<SubmitWorkspaceDraftResp> => {
  const url = '/weaver/api/v1/npc/workspace/draft_submit';

  return await request.post(url, data);
};

export const postWorkspaceDraftDelete = async (
  data: DeleteWorkspaceDraftReq
): Promise<DeleteWorkspaceDraftResp> => {
  const url = '/weaver/api/v1/npc/workspace/draft_delete';

  return await request.post(url, data);
};

export const postGetNpcPrologueVoice = async (
  data: GetNpcPrologueVoiceReq
): Promise<GetNpcPrologueVoiceResp> => {
  const url = '/weaver/api/v1/npc/default_get_npc_prologue_voice';

  return await request.post(url, data);
};

export const postDraftModeration = async (
  data: DraftModerationReq
): Promise<DraftModerationResp> => {
  const url = '/weaver/api/v1/npc/workspace/draft_moderation';

  return await request.post(url, data);
};

export const postGetWorkspaceBanner = async (
  data: GetWorkspaceBannerReq,
  config?: AxiosRequestConfig
): Promise<GetWorkspaceBannerResp> => {
  const url = '/weaver/api/v1/npc/workspace/banner_list';

  return await request.post(url, data, config);
};

export const postGetChatModels = async (
  data: any,
  config?: AxiosRequestConfig
): Promise<GetChatModelsResp> => {
  const url = '/weaver/api/v1/npc/workspace/chat_model_list';

  return await request.post(url, data, config);
};
